import { HoodDuctCoverFinish } from './Enums';
import {
  ductCoverHeightLookup,
  hoodWidthLookup,
  insertBlowerCapacityLookup,
  insertManufacturerLookup,
  insertModelNumberLookup,
} from './hoodLookups';
import { HoodState } from './HoodState';
import { colorLookup } from './lookups';

export class HoodSummary {
  /**
   * The current state of the hood.
   * @type {HoodState}
   */
  #state;

  /**
   * @param {HoodState} state
   */
  constructor(state) {
    this.#state = state;
  }

  /**
   * The hood color for the summary page.
   * @returns {string}
   */
  color() {
    return `Color: ${colorLookup[this.#state.color]}`;
  }

  /**
   * The hood duct cover finish for the summary page.
   * @returns {string}
   */
  ductCoverFinish() {
    const isStainlessSteel =
      this.#state.ductCoverFinish === HoodDuctCoverFinish.stainlessSteel;
    const color = isStainlessSteel
      ? 'Stainless Steel [standard]'
      : `${colorLookup[this.#state.color]} [custom]`;

    return `Duct Cover Finish: ${color}`;
  }

  /**
   * The hood duct cover finish for the summary page.
   * @returns {string}
   */
  ductCoverHeight() {
    const height = ductCoverHeightLookup[this.#state.ductCoverHeight];

    return `Duct Cover Height: ${height}`;
  }

  /**
   * The hood width for the summary page.
   * @returns {string}
   */
  hoodWidth() {
    const width = hoodWidthLookup[this.#state.modelNumber];

    return `Hood Width: ${width}`;
  }

  /**
   * The hood insert blower capacity for the summary page.
   * @returns {string}
   */
  insertBlowerCapacity() {
    const maxCFM = insertBlowerCapacityLookup[this.#state.insertModel];

    return `Insert Blower Capacity: ${maxCFM.toLocaleString()} CFM`;
  }

  /**
   * The hood insert manufacturer for the summary page.
   * @returns {string}
   */
  insertManufacturer() {
    const manufacturer = insertManufacturerLookup[this.#state.insertChoice];

    return `Insert Manufacturer: ${manufacturer}`;
  }

  /**
   * The hood insert model number for the summary page.
   * @returns {string}
   */
  insertModelNumber() {
    const modelNumber = insertModelNumberLookup[this.#state.insertModel];

    return `Insert Model Number: ${modelNumber}`;
  }

  /**
   * The hood model for the summary page.
   * @returns {string}
   */
  modelNumber() {
    return `Model number: ${this.#state.modelNumber}`;
  }
}
